import type { JSX } from 'solid-js';
import { t } from '../../i18n';
import { MoveIcon } from './MoveIcon';

// The two buttons that open Move work on the card (#6772, prototype mwBtn `:1692-1696` and the
// simplified card's `.cmp-acts`, `:2404`): a swap icon and "Move" in the Now header, and the
// flow icon with "Move work" on the simplified card, both named "Move work to another machine".
// The card shows them only where the panel can open (an admin on an own-org machine, online,
// with work on it, in an org of two machines or more); the panel itself says why a move cannot
// go. Focus comes back to the Now header's button when the panel closes.

export function MoveWorkButton(props: {
  readonly variant: 'now' | 'simple';
  readonly expanded: boolean;
  readonly onOpen: () => void;
}): JSX.Element {
  return (
    <button
      type="button"
      class="mission-send__open move-work__open"
      data-variant={props.variant}
      data-move-work=""
      aria-label={t('fleet.move.work_open_title')}
      aria-expanded={props.expanded}
      title={t('fleet.move.work_open_title')}
      onClick={() => props.onOpen()}
    >
      <MoveIcon glyph={props.variant === 'now' ? 'swap' : 'flow'} />
      {t(props.variant === 'now' ? 'fleet.move.button' : 'fleet.move.menu_move')}
    </button>
  );
}
